import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Badge,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import {useBalance} from "../../Context/BalanceContext";
import {useNavigate} from "react-router-dom";

const Balance = ({}) => {
  const { balance } = useBalance();
  const navigate = useNavigate();




  return (
      <Box sx={{ position: "relative" }}>
        {
          (balance || balance == 0) ?
              <Typography sx={{
                fontSize:'14px',
                fontWeight:'bold',
                color:'#eca601',
                cursor:'pointer'
              }}
              onClick={() => navigate('/make-recharge')}>
                ${balance}
              </Typography> :
              <CircularProgress></CircularProgress>
        }


      </Box>
  );
};

export default Balance;
